import { z } from 'zod';

const linkedAccountSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  provider_id: z.string(),
  provider: z.string(),
  created_at: z.string(),
  external_user_id: z.string().nullable(),
});

export const linkedAccountsSchema = z
  .object({
    objects: z.array(linkedAccountSchema),
  })
  .transform((data) => data.objects.map((account) => account.provider.toLowerCase()));

export type LinkedAccounts = z.infer<typeof linkedAccountsSchema>;
export type LinkedAccountsResponse = z.input<typeof linkedAccountsSchema>;
